import {useMemo} from "react";
import {useRouteTemplates} from "hooks/useRouteTemplates";
import {useSetting} from "../../contexts/setting";
import cn from "classnames";
import "./index.css";
import TemplateControls from "../../layout/TemplateControls";
import SortableList from "../../layout/SortableList";
import Releases from "../Releases";

const LiveStream = () => {
  const {visible, currentVideoPopup, dataChannel, bases} = useSetting();

  // Without the banners an admin removed (libs/bannerComposition.ts).
  const filteredTemplates = useRouteTemplates("social");
  const bannerIds = useMemo(
    () => filteredTemplates.map((template) => template.id),
    [filteredTemplates]
  );
  const hasOnlyOneBanner = bannerIds.length === 1;

  // A product that carries its own offering draws that offering's page, not
  // this channel's list: JetBrains Air brings the release sets — What's New,
  // the emails, the screenshot mockup — with it. `dataChannel` is the same
  // home scope the data reads go through (src/data/offering.ts), so the page
  // and the scene it loads cannot disagree.
  if (dataChannel === "releases") return <Releases />;

  return (
    <SortableList
      items={filteredTemplates}
      useDragHandle={true}
      getItemClassName={(item) =>
        cn("template-wrap", {
          hidden: !hasOnlyOneBanner && !visible.some((x) => x === item.id),
          popup: currentVideoPopup === item.id,
        })
      }
      // `--base-color` is a scene scalar on `.templates-inner` (App.js); a
      // banner that set its base apart on its look redeclares it here, so the
      // fill under its artwork is its own and every other banner keeps the
      // shared one. Same element the renderer screenshots, so an export and
      // the editor cannot disagree.
      getItemStyle={(item) => (bases?.[item.id] ? {"--base-color": `#${bases[item.id]}`} : undefined)}
      renderItem={(item, {listeners, attributes} = {}) => (
        <>
          <div
            className="template-annotation"
            {...(listeners || {})}
            {...(attributes || {})}
            style={{cursor: "grab"}}
          >
            <span
              className="label"
              data-tooltip={item.tooltip || null}
            >{`${item.label} (${item.dimensions}${item.suffix || ""})`}</span>
            <TemplateControls
              id={item.id}
              templateChannel="social"
              hasOnlyOneBanner={hasOnlyOneBanner}
              bannerIds={bannerIds}
            />
          </div>
          {item.getComponent()}
        </>
      )}
    />
  );
};

export default LiveStream;
